"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HerenciaDeMendoza() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="165899" id="the-heritage" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-1/4 w-[50vw] h-[50vw] bg-secondary/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[40vw] h-[40vw] bg-primary/10 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="relative p-3 md:p-4 border border-border/20 bg-card/5 backdrop-blur-sm">
              <AspectRatio ratio={3 / 4} className="overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600482/img/legendary_winemaker_bw_portrait.png" alt="Grainy black and white portrait of the founding winemaker at VineEssence" className="object-cover w-full h-full grayscale contrast-125 brightness-75 hover:scale-105 transition-transform duration-1000 ease-in-out" />
              </AspectRatio>
              
              {}
              <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-secondary/30" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-secondary/30" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b border-l border-secondary/30" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-secondary/30" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <span className="text-sm font-mono tracking-[0.3em] text-secondary uppercase mb-6 block">
              EST. 1924
            </span>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light tracking-tight mb-8 text-foreground leading-[1.1]">
              The Art of <br className="hidden md:block" />
              <span className="italic text-muted-foreground">Minimal Intervention</span>
            </h2>
            
            <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-sans font-light leading-relaxed tracking-normal">
              <p>
                At VineEssence, our heritage is rooted in the belief that the finest wines are not made, but grown. We honor the unique character of our estate by stepping back, allowing the natural cycle of the vineyard to express itself without compromise.
              </p>
              <p>
                Our philosophy ensures that every bottle captures the true spirit of the harvest. From the cellar slate soils to the hand-tended vines, we preserve the purity of the fruit to deliver a wine of unparalleled structure, elegance, and deep-rooted authenticity.
              </p>
            </div>

            <div className="mt-12">
              <Link to="/OurVineyardPage" className="group inline-flex items-center gap-4 text-secondary hover:text-foreground transition-colors duration-300">
                <span className="font-serif text-xl md:text-2xl italic tracking-wide">
                  Read Our Story
                </span>
                <span className="relative flex items-center justify-center w-10 h-10 rounded-full border border-secondary/30 group-hover:border-secondary transition-colors duration-300 overflow-hidden">
                  <ArrowRight className="w-5 h-5 absolute transition-transform duration-500 ease-out group-hover:translate-x-8" strokeWidth={1} />
                  <ArrowRight className="w-5 h-5 absolute -translate-x-8 transition-transform duration-500 ease-out group-hover:translate-x-0" strokeWidth={1} />
                </span>
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>;
}